import { render, staticRenderFns } from "./verify-site-change.vue?vue&type=template&id=8b2370a8&scoped=true&"
import script from "./verify-site-change.vue?vue&type=script&lang=js&"
export * from "./verify-site-change.vue?vue&type=script&lang=js&"
import style0 from "./verify-site-change.vue?vue&type=style&index=0&id=8b2370a8&lange=scsss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2370a8",
  null
  
)

export default component.exports